var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 27,
    viewBox: "0 0 41 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4752 10.4007C31.9119 7.56351 30.375 5.00875 28.1271 3.17273C25.8792 1.33671 23.0596 0.333331 20.15 0.333985C15.3038 0.333985 11.0948 3.06732 8.99871 7.06732C6.53407 7.33204 4.2548 8.49266 2.59884 10.3262C0.942877 12.1597 0.0270558 14.5368 0.0273438 17.0007C0.0273438 22.5173 4.53818 27.0007 10.0887 27.0007H31.8883C36.5165 27.0007 40.2727 23.2673 40.2727 18.6673C40.2727 14.2673 36.8351 10.7007 32.4752 10.4007ZM23.5038 15.334V22.0007H16.7962V15.334H11.7656L20.15 7.00065L28.5345 15.334H23.5038Z",
    fill: "#111111",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUpload);
export default __webpack_public_path__ + "static/media/ic_upload.b65168353dbab188520c81308ed5657a.svg";
export { ForwardRef as ReactComponent };